import { DOCUMENT } from '@angular/common';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, HostListener, Input, ViewChild, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { Observable } from 'rxjs';
import { AppState, selectBlockDocumentInCommonState, selectDisplayLoginDialogInCommonState, selectLanguageInCommonState, selectLoadingCommonState } from './app-state.index';
import { Language, MessageTypes } from './shared/model/enums';
import { AppAuthService } from './shared/services/app-auth.service';
import { AdvMessageService } from './shared/services/message.service';
import { setIsLoading } from './shared/state/actions/‏‏shared-common.action';
import { ResolutionType } from './shared/model/enums';
import { AppResolutionType } from 'app/shared/common/appResolution';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush

})

export class AppComponent {
  constructor(private store: Store<AppState>, private localizationService: LocalizationService, private translateService: TranslateService,
    private messagesService: AdvMessageService, private titleService: Title, private changeRef: ChangeDetectorRef, private authService: AppAuthService,
    @Inject(DOCUMENT) private document: Document) {
    localizationService.InitializeLanguage();
    store.select(selectLanguageInCommonState).subscribe(language => {
      changeDirection(language);
    }
    );
    // setTimeout(() => {
    //   if (AppResolutionType == ResolutionType.Mobile)
    //     messagesService.showMessage(MessageTypes.info, null, this.localizationService.Translate('GENERAL.MESSAGES.SUPPORT_MOBILE'))
    // }, 1000);


  }

  isLoading$: any;
  divElement: any;
  displayLoginDialog$: Observable<boolean>;
  blockDocument$: Observable<boolean>;
  dierction: string;

  ngOnInit() {
    this.authService.getOrLoadUserInfo().subscribe();
    this.store.dispatch(setIsLoading({ isLoading: true, divElement: null }))
    this.isLoading$ = this.store.select(selectLoadingCommonState);
    this.displayLoginDialog$ = this.store.select(selectDisplayLoginDialogInCommonState);
    this.blockDocument$ = this.store.select(selectBlockDocumentInCommonState);

    this.messagesService.onAddMessage.subscribe(() => {
      this.changeRef.detectChanges();
    });

    if (this.translateService.store.translations[this.translateService.currentLang]) {
      this.titleService.setTitle(this.localizationService.Translate('GENERAL.SITE_TITLE'));
    } else {
      this.translateService.onLangChange.subscribe(() => {
        this.titleService.setTitle(this.localizationService.Translate('GENERAL.SITE_TITLE'));
      });
    }


  }
}
function changeDirection(language: Language) {
  let direction;
  switch (language) {
    case Language.he:
      direction = "rtl";
      document.body.classList.replace('ltr', 'rtl');
      break;
    default:
      direction = "ltr";
      document.body.classList.replace('rtl', 'ltr');
      break;
  }
  document.dir = direction;
}

